/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLetterYear: {
  name: 'letter-year';
  data: string;
} = {
  name: 'letter-year',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 1h1.558l4.377 6.17h.13L12.442 1H14L8.67 8.37V14H7.33V8.37L2 1Z" fill="currentColor"/></svg>`,
};
